import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

const stored = localStorage.getItem("taskmatrix_token");
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

export function setToken(token) {
  if (token) {
    localStorage.setItem("taskmatrix_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("taskmatrix_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

export default api;
